<template>
  <div class="addAddress-popup">
    <b-modal
      id="downlineRepAddressAdd"
      centered
      size="lg"
      hide-footer
      hide-header-close
      no-close-on-backdrop
    >
      <template #modal-header>
        <div class="add-address-header">
          <h4>Add New {{ type }} Address</h4>

          <b-button variant="close-btn" class="btn-container" @click="closeModal">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="addAddress-form">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form
              @submit.prevent="handleSubmit(addAddress)"
              ref="addAddressContainer" >
            
              <div class="form-group row">
                <input-text
                  :rules="{ required: true }"
                  labelFor="address1"
                  labelName="Street Address"
                  inputName="address1"
                  inputClass="address1 info-field"
                  :vmodel.sync="form.address1"
                  formGroupClass="col-xxl-6 col-lg-6 col-md-6 mb-3"
                />

                <input-text
                  :rules="{ required: false }"
                  labelFor="address2"
                  labelName="Apt/Suite/Other"
                  inputName="address2"
                  inputClass="address2 info-field"
                  :vmodel.sync="form.address2"
                  formGroupClass="col-xxl-6 col-lg-6 col-md-6 mb-3"
                />
              </div>

              <div class="form-group row">
                <input-text
                  :rules="{ required: true }"
                  labelFor="city"
                  labelName="City"
                  inputName="city"
                  inputClass="city info-field"
                  :vmodel.sync="form.city"
                  formGroupClass="col-xxl-6 col-lg-6 col-md-6 mb-3"
                />
                <input-text
                  :rules="{ required: true }"
                  labelFor="state"
                  labelName="State"
                  inputName="state"
                  inputClass="state info-field no-check"
                  :vmodel.sync="form.state"
                  formGroupClass="col-xxl-6 col-lg-6 col-md-6 mb-3"
                  placeholder="Choose a State"
                  :readonly="true"  
                />
              </div>

              <div class="form-group row">
                <input-text
                  :rules="{ required: true, digits: 5 }"
                  labelFor="zip"
                  labelName="Zip"
                  inputName="zip"
                  :vmodel.sync="form.zip"
                  type="number"
                  formGroupClass="col-xxl-6 col-lg-6 col-md-6 mb-3"
                  inputClass="zip info-field"
                  @input="autoFillCityState" 
                />
              </div>

              <div class="form-group row">
                <div class="form-check col-xxl-6 col-lg-6 col-md-6 mb-3">
                  <toggle-element
                    :vmodel.sync="form.is_primary"
                    @onClicked="form.is_primary = !form.is_primary"
                    text="Set as Primary"
                  />
                </div>
                <div class="form-check col-xxl-6 col-lg-6 col-md-6 mb-3">
                  <input
                    class="form-check-input add-new-address-checkbox"
                    type="checkbox"
                    id="flexCheckDefault"
                    v-model="continue_with_address_validation"
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    Validate with USPS
                  </label>
                </div>
              </div>

              <div class="w-100 text-center">
                <b-button class="univ-btn" type="submit">
                  {{ isCreate ? "Creating" : "Create" }}
                </b-button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";

export default {
  name: "DownlineRepAddressAdd",
  props: {
    type: {
      required: true,
    },
  },
  data: () => ({
    form: {
      address1: "",
      address2: "",
      city: "",
      state: null,
      zip: "",
      type: null,
      usps_verified: false,
      is_primary: false,
      agent_id: "",
    },
    addressTypes: Helper.getAddressTypes(),
    // states: Helper.getStates(),
    isCreate: false,
    continue_with_address_validation: false,
  }),
  watch: {
  "form.zip"(newVal) {
    if (newVal && newVal.length === 5) {
      this.autoFillState({ target: { value: newVal } });
    }
  }
},

  methods: {
    closeModal() {
      this.form = {
        address1: "",
        address2: "",
        city: "",
        state: null,
        zip: "",
        type: this.type,
        usps_verified: false,
        is_primary: false,
        agent_id: atob(this.$route.params.downlineRepId),
      };
      this.$bvModal.hide("downlineRepAddressAdd");
      if (this.type == "payment") {
        this.$emit("onPaymentModalClose");
      }
    },
    reset() {
      this.form = {
        address1: "",
        address2: "",
        city: "",
        state: null,
        zip: "",
        type: this.type,
        usps_verified: false,
        is_primary: false,
        agent_id: atob(this.$route.params.downlineRepId),
      };
      this.$refs.observer.reset();
      this.$bvModal.hide("downlineRepAddressAdd");
      this.$emit("onSuccess");
    },

   async autoFillState(event) {
  let inputValue = event?.target?.value || this.form.zip;

  if (inputValue.length > 5) {
    inputValue = inputValue.slice(0, 5);
    this.form.zip = inputValue;
  }

  this.form.zip = inputValue;

  if (inputValue.length === 5) {
    try {
      const url = process.env.VUE_APP_VALIDATE_ZIP;  
      console.log('Making POST request to:', url);

      const res = await axios.post(url, { zip: inputValue });
      console.log('ZIP API response:', res.data);

      if (res.data.status === "success" && res.data.data && res.data.data[0]) {
        this.form.state = res.data.data[0].state_abbreviation || null;
      }
    } catch (err) {
      console.error("ZIP validation failed:", err.response?.data || err);
      this.$notify("Invalid Zip Code", "error");
    }
  }
},


    validateUsps() {
      let url = this.$endpoint.API_URL + `v1/validate-address-usps`;
      const uspsAxios = axios.create();
      uspsAxios
        .post(url, this.form)
        .then(() => {
          this.form.usps_verified = true;
          this.createAddress();
        })
        .catch((err) => {
          let [inputClass, errorMessage] = [
            `.${err.response.data.data[0].target_element}`,
            err.response.data.data[0].error_message,
          ];
          this.$notify(errorMessage, "error");
          console.log(inputClass);

          setTimeout(() => {
            this.$refs.observer.reset();
          }, 2000);
        });
    },

    createAddress() {
      this.isCreate = true;
      const url = `v2/add-address`;
      let loader = this.$loading.show({
        container: this.$refs.addAddressContainer,
      });
      this.form.type = this.type;
      Api.post(url, this.form)
        .then((res) => {
          this.reset();
          this.$notify(res.data.message);
          if (this.type == "payment") {
            this.$emit("onSuccessPaymentAdd", "check");
          }
        })
        .catch((err) => {
          this.$notify(err.response.data.message, "error");
        })
        .finally(() => {
          this.isCreate = false;
          loader.hide();
        });
    },

    addAddress() {
      this.form.agent_id = atob(this.$route.params.downlineRepId);
      if (this.continue_with_address_validation) {
        this.validateUsps();
      } else {
        this.createAddress();
      }
    },
  },
};
</script>

<style>
#addAddress .modal-content {
  border: 0px;
  border-radius: 10px;
}
#addAddress .modal-header {
  justify-content: center;
  border: 0;
  padding: 25px 0;
  position: relative;
}
#addAddress .modal-footer {
  border-top: 0;
  padding: 0 15px 25px 15px;
}
.addAddress-header h4 {
  font-size: 20px;
  color: #2c3f58;
  font-weight: 600;
  margin: 0;
}
.add-address-header .btn-container {
  position: absolute;
  top: -15px;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.addAddress-form label {
  color: #5e5e5e;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}
#addAddress .modal-footer .univ-btn {
  max-width: 300px;
}
</style>
